/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CloneReport,
    CloneReportFromJSON,
    CloneReportFromJSONTyped,
    CloneReportToJSON,
} from './CloneReport';

/**
 *
 * @export
 * @interface ApiResultOfMapOfstringAndCloneReport
 */
export interface ApiResultOfMapOfstringAndCloneReport {
    /**
     *
     * @type {{ [key: string]: CloneReport; }}
     * @memberof ApiResultOfMapOfstringAndCloneReport
     */
    data?: { [key: string]: CloneReport; };
    /**
     *
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndCloneReport
     */
    message?: string;
    /**
     *
     * @type {object}
     * @memberof ApiResultOfMapOfstringAndCloneReport
     */
    messageValues?: object;
    /**
     *
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndCloneReport
     */
    requestId?: string;
    /**
     *
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndCloneReport
     */
    result?: ApiResultOfMapOfstringAndCloneReportResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfMapOfstringAndCloneReportResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfMapOfstringAndCloneReportFromJSON(json: any): ApiResultOfMapOfstringAndCloneReport {
    return ApiResultOfMapOfstringAndCloneReportFromJSONTyped(json, false);
}

export function ApiResultOfMapOfstringAndCloneReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfMapOfstringAndCloneReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': !exists(json, 'data') ? undefined : (mapValues(json['data'], CloneReportFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfMapOfstringAndCloneReportToJSON(value?: ApiResultOfMapOfstringAndCloneReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': value.data === undefined ? undefined : (mapValues(value.data, CloneReportToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}
